import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import './styles.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';

/** Web app version sent to GET /api/v1/version for the update check. Bump on every release. */
const VERSION = '0.1.0';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App version={VERSION} />
  </StrictMode>,
);
